module.exports = __webpack_public_path__ + "f80ed9ca7a73728b85f5b500be1fcb9a.svg";